import { defineComponent as N, mergeModels as S, useModel as R, ref as W, inject as z, useId as F, computed as w, createBlock as g, createCommentVNode as A, openBlock as i, mergeProps as H, unref as m, withCtx as o, createVNode as u, createElementBlock as I, renderSlot as _, Fragment as K, renderList as T, createTextVNode as f, toDisplayString as h, isRef as q, withModifiers as G } from "vue";
import { SearchInputKey as J } from "./SearchInput.vue2.js";
import { useOUIAProps as Q } from "../../helpers/ouia.js";
import C from "../TextInput.vue2.js";
import O from "../Button.vue2.js";
import X from "../Panel/Panel.vue2.js";
import Y from "../Panel/PanelMain.vue2.js";
import Z from "../Panel/PanelMainBody.vue2.js";
import x from "../Form/Form.vue2.js";
import B from "../Form/FormGroup.vue2.js";
import ee from "../Form/ActionGroup.vue2.js";
import { useEventListener as v } from "@vueuse/core";
const ce = /* @__PURE__ */ N({
  name: "PfAdvancedSearchMenu",
  __name: "AdvancedSearchMenu",
  props: /* @__PURE__ */ S({
    searchMenuOpen: { type: Boolean },
    resetButtonLabel: { default: "Reset" },
    submitSearchButtonLabel: { default: "Search" },
    attributes: { default: () => [] },
    advancedSearchDelimiter: {},
    onClear: {},
    getAttrValueMap: {}
  }, {
    modelValue: { default: "" },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ S(["search", "toggle-advanced-menu"], ["update:modelValue"]),
  setup(y, { emit: L }) {
    const l = y, P = Q({ id: l.ouiaId, safe: l.ouiaSafe }), c = R(y, "modelValue"), s = L, E = W(null), n = z(J), V = F();
    v("mousedown", b), v("touchstart", b), v("keydown", j);
    function M(e) {
      return w({
        get() {
          var a;
          const t = ((a = l.getAttrValueMap) == null ? void 0 : a.call(l)) ?? {};
          return Object.hasOwnProperty.call(t, e) ? t[e] : "";
        },
        set(t) {
          var d;
          const a = ((d = l.getAttrValueMap) == null ? void 0 : d.call(l)) ?? {};
          a[e] = t;
          let r = "";
          Object.entries(a).forEach(([k, $]) => {
            $.trim() !== "" && (k !== "haswords" ? r = `${r} ${k}${l.advancedSearchDelimiter}${$}` : r = `${r} ${$}`);
          }), c.value = r.replace(/^\s+/g, "");
        }
      });
    }
    const D = w(() => {
      const e = [];
      for (const t of l.attributes) {
        const a = typeof t == "string" ? t : t.attr;
        e.push({
          attr: a,
          display: typeof t == "string" ? t : t.display,
          computed: M(a)
        });
      }
      return e;
    }), p = M("haswords"), U = (e) => {
      var t;
      s("search", c.value, e, ((t = l.getAttrValueMap) == null ? void 0 : t.call(l)) ?? {}), l.searchMenuOpen && s("toggle-advanced-menu", e);
    };
    function b(e) {
      var a;
      const t = (a = n == null ? void 0 : n.$el.value) == null ? void 0 : a.contains(e.target);
      l.searchMenuOpen && !t && s("toggle-advanced-menu", e);
    }
    function j(e) {
      var t, a;
      l.searchMenuOpen && e.key === "Escape" && ((t = n == null ? void 0 : n.$el.value) != null && t.contains(e.target)) && (s("toggle-advanced-menu", e), (a = n == null ? void 0 : n.input.value) == null || a.focus());
    }
    return (e, t) => e.searchMenuOpen ? (i(), g(X, H({ key: 0 }, m(P), { variant: "raised" }), {
      default: o(() => [
        u(Y, null, {
          default: o(() => [
            u(Z, null, {
              default: o(() => [
                u(x, null, {
                  default: o(() => [
                    (i(!0), I(K, null, T(D.value, (a, r) => (i(), g(B, {
                      key: `${a.attr}_${r}`,
                      "field-id": `${a.attr}_${r}`
                    }, {
                      label: o(() => [
                        _(e.$slots, `attribute:${a.attr}`, {}, () => [
                          f(h(a.display), 1)
                        ])
                      ]),
                      default: o(() => [
                        u(C, {
                          id: `${a.attr}_${r}`,
                          ref_for: !0,
                          ref: (d) => r === 0 ? E.value = d : null,
                          modelValue: a.computed.value,
                          "onUpdate:modelValue": (d) => a.computed.value = d,
                          type: "text"
                        }, null, 8, ["id", "modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 2
                    }, 1032, ["field-id"]))), 128)),
                    u(B, { "field-id": m(V) }, {
                      label: o(() => [
                        _(e.$slots, "words-attr-label", {}, () => [
                          t[1] || (t[1] = f("Has words"))
                        ])
                      ]),
                      default: o(() => [
                        u(C, {
                          id: m(V),
                          modelValue: m(p),
                          "onUpdate:modelValue": t[0] || (t[0] = (a) => q(p) ? p.value = a : null),
                          type: "text"
                        }, null, 8, ["id", "modelValue"])
                      ]),
                      _: 3
                    }, 8, ["field-id"]),
                    _(e.$slots, "default"),
                    u(ee, null, {
                      default: o(() => [
                        u(O, {
                          variant: "primary",
                          type: "submit",
                          disabled: !c.value,
                          onClick: G(U, ["prevent"])
                        }, {
                          default: o(() => [
                            f(h(e.submitSearchButtonLabel), 1)
                          ]),
                          _: 1
                        }, 8, ["disabled"]),
                        e.onClear ? (i(), g(O, {
                          key: 0,
                          variant: "link",
                          type: "reset",
                          onClick: e.onClear
                        }, {
                          default: o(() => [
                            f(h(e.resetButtonLabel), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick"])) : A("", !0)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 3
                })
              ]),
              _: 3
            })
          ]),
          _: 3
        })
      ]),
      _: 3
    }, 16)) : A("", !0);
  }
});
export {
  ce as default
};
